import SharedBaseService from './shared.base.service'

class SharedVideoService extends SharedBaseService{

    async getVideo(token, jwt) {
        let url = `/api/v1/share/video/${token}`
        const header = {
            'Content-Type': 'application/json',
        }
        if (jwt){
            header['x-token'] = jwt
        }

        const response = await fetch(
            url,
            {
                method: 'GET',
                headers: header,
                credentials: 'same-origin',
            }
        )
        if ( response.ok) {
            const data = await response.json()
            return data;
        }
        else if ( response.status == 401) {
            throw Error("401")
        }
    }

    async getVideoFolder(token, jwt) {

        let url = `/api/v1/share/videos/${token}`
        const header = {
            'Content-Type': 'application/json',
        }
        if (jwt){
            header['x-token'] = jwt
        }
        const response = await fetch(
            url,
            {
                method: 'GET',
                headers: header,
                credentials: 'same-origin',
            }
        )
        if ( response.ok) {
            const data = await response.json()
            return data;
        }
        else if ( response.status == 401) {
            throw Error("401")
        }
    }

    async getVideos (folderId, token) {
        const response = await fetch(
            `/api/v1/share/videos/files?folderId=${folderId}&token=${token}`,
            {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                },
                credentials: 'same-origin',
            }
        )
        const data = await response.json()
        return data;
    }

}

const sharedVideoService = new SharedVideoService();

export default sharedVideoService;